module.exports = __webpack_public_path__ + "assets/smart-asset-sun.27f6e281.svg";